import axiosInstance from "@/services/http/axios-instance";

export class AuthApi {
  startLogin(phone) {
    return axiosInstance.post("/auth/login", {
      phone,
    });
  }

  finishLogin(phone, otp, operationId) {
    return axiosInstance.post("/auth/login/otp", {
      phone,
      otp_code: otp,
      operation_id: operationId,
    });
  }

  refreshToken() {
    return axiosInstance.post("/auth/refresh");
  }

  finishCallLogin(phone, loginTransactionId) {
    return axiosInstance.post("/auth/login/phone-call/verify", {
      phone,
      transaction_id: loginTransactionId,
    });
  }
}
